export default __webpack_public_path__ + "static/media/fog.43701588.png";